export default __webpack_public_path__ + "static/media/Astronaut_07.220a474f.png";